import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { UserList } from "@/components/ui/UserList";
import { Loading } from "@/layouts/components";
import { useGetUserFavoritesQuery } from "@/store/api";
export var FavoritesUserList = function (props) {
    var userFavoritesGetState = useGetUserFavoritesQuery({
        text: props.searchQuery,
    });
    return (_jsxs(_Fragment, { children: [_jsx(Loading, { isActive: !userFavoritesGetState.isSuccess, loadingKey: "userFavorites" }), userFavoritesGetState.isSuccess && (_jsx(UserList, { onDetailsClick: props.onDetailsClick, data: userFavoritesGetState.data }))] }));
};
